<script>
    import {createEventDispatcher} from "svelte";

    export let data;
    export let index;
    export let slotName;

    $: isImagePresent = data && data.Image;

    const dispatch = createEventDispatcher();

    let inputRef;

    let isMouseOver = false;
    let isDragOver = false;

    function onDragStart(event) {
        event.dataTransfer.effectAllowed = "move";
        event.dataTransfer.dropEffect = "move";
        event.dataTransfer.setData("text/plain", index);
    }

    function onDrop(event) {
        let files = event.dataTransfer.files;

        if (files.length > 0) {
            dispatch("upload", {
                files: files,
                index: index,
            });
        } else {
            event.dataTransfer.dropEffect = "move";

            dispatch("drop", {
                event: event,
                index: index,
            });
        }
    }

    function onInputChange() {
        if (inputRef.files.length === 0) return;

        dispatch("upload", {
            files: inputRef.files,
            index: index,
        });
    }

    function onRemove() {
        dispatch("remove", {
            index: index,
        });
    }

    function onUploadClick() {
        inputRef.click();
    }

    function onMouseEnter() {
        isMouseOver = true;
    }

    function onMouseLeave() {
        isMouseOver = false;
    }
</script>

<div
    class="w-32 bg-white rounded-2xl shadow-xl m-2 flex flex-col"
    draggable={true}
    on:dragstart={onDragStart}
    on:drop|preventDefault={onDrop}
    on:mouseenter={onMouseEnter}
    on:mouseleave={onMouseLeave}
    ondragover="return false"
>
    <div class="relative grow items-center" style="min-height:128px">
        {#if isImagePresent}
            {#if data.Image.startsWith("data:application/octet-stream;base64")}
                <span class="align-middle">Binary<br/>Data</span>
            {:else}
                <img src={data.Image} class="object-cover min-h-32"/>
            {/if}
        {/if}
        <div class="absolute inset-0 flex flex-col">
            {#if isMouseOver && isImagePresent}
                <div
                    class="flex-grow justify-center items-center absolute inset-0 flex opacity-70 bg-black"
                >
                    <div
                        class="text-2xl font-medium align-middle text-white"
                        on:click={onRemove}
                    >
                        ✕
                    </div>
                </div>
            {:else if !isImagePresent}
                <div
                    class="flex-grow justify-center items-center absolute inset-0"
                    on:click={onUploadClick}
                >
                    <div
                        class="flex  border-dashed border-2 border-slate-300 bg-zinc-50 justify-center w-full h-full justify-center items-center"
                    >
                        <span
                            class="text-4xl font-medium text-slate-400 m-2 align-middle"
                        >+</span
                        >
                    </div>
                </div>
            {/if}
        </div>
        <input
            autocomplete="off"
            bind:this={inputRef}
            class="hidden"
            on:change={onInputChange}
            type="file"
        />
    </div>

    <div class="text-center">
        <span class="text-xl font-medium text-slate-600 m-1">{slotName}</span>
    </div>
</div>
